import React from 'react'
import { useAuth } from '../../../../Contexts/AuthContext'
import { useEffect } from 'react'

const SignInWithGoogleButtonDEV = () => {
  const { handleGoogle, login, error, setError } = useAuth()

  async function handleGoogleClick(response) {
    let googleJWT = await handleGoogle(response)
    if (googleJWT === undefined || googleJWT === null) {
      setError('Something has failed, try again')
    } else {
      login(googleJWT, error => {
        setError(error)
      })
    }
  }

  useEffect(() => {
    const googleScript = document.getElementById('google-map-script')

    googleScript.addEventListener('load', () => {
      // Patiently waiting to do the thing
      setupGoogle()
    })

    setupGoogle()
  }, [window.google])

  function setupGoogle() {
    /* global google */
    if (window.google) {
      google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleGoogleClick,
      })

      google.accounts.id.renderButton(
        document.getElementById('sign-in-div-deprecated'),
        {
          // type: "standard",
          theme: 'filled_black',
          // size: "small",
          text: 'continue_with',
          shape: 'pill',
        }
      )

      // google.accounts.id.prompt();
    }
  }

  return (
    <>
      <div className="orGoogleText">or</div>
      <div id="sign-in-div-deprecated"></div>
    </>
  )
}

export default SignInWithGoogleButtonDEV
